import React from 'react';

import { NonSequencedFlowItem as NonSequencedFlowItemComponent } from '../../../containers/student/NonSequencedFlowItem';
import { NonSequencedFlowItem, TrackingStatus } from '@ael/core-api';
import { MenuItemLabel } from '@ael/shared-components-library';

interface NonSequencedNavigationMenuItemProps {
  item: NonSequencedFlowItem;
  parentItemId: string | null;
  nestedLevel: number;
  isLinearModeOn: boolean;
  TrackingStatusProvider: React.FC<{
    itemId: string;
    render: (trackingStatus: TrackingStatus) => React.ReactElement;
  }>;
}

export const NonSequencedNavigationMenuItem: React.FC<NonSequencedNavigationMenuItemProps> = ({
  item,
  parentItemId,
  nestedLevel,
  isLinearModeOn,
  TrackingStatusProvider,
}) => (
  <TrackingStatusProvider
    itemId={item.id}
    render={(trackingStatus: TrackingStatus) => (
      <NonSequencedFlowItemComponent
        item={item}
        key={item.id}
        trackingStatus={trackingStatus}
        parentItemId={parentItemId}
        nestedLevel={nestedLevel}
        isLinearModeOn={isLinearModeOn}
      >
        <MenuItemLabel>{item.title}</MenuItemLabel>
      </NonSequencedFlowItemComponent>
    )}
  />
);
